import { find, pick, omit } from 'lodash';
import React from 'react';
import Select from '../../../components/form/Select';
import Margin from '../components/Margin';
import { useScaleTicketingContext } from '../Context';

const { Option } = Select;

const Customer = () => {
  const { customers, form, handleChange } = useScaleTicketingContext();

  const handleCustomerChange = React.useCallback(
    ref => {
      const targetCustomer = find(customers, { crn: ref });
      if (targetCustomer) {
        handleChange('vehicle', s => ({
          ...s,
          configuration: {
            ...omit(s.configuration, 'project'),
            customer: {
              ...pick(targetCustomer, ['id', 'name']),
              customerRef: targetCustomer.crn,
            },
          },
        }));
      }
    },
    [handleChange, customers]
  );

  return (
    <Margin top={10}>
      <div className="field-label">Customer</div>
      <Select
        value={form?.vehicle?.configuration?.customer?.customerRef || ''}
        showSearch
        filterOption={(input, option) => option?.children?.toLowerCase?.().indexOf(input.toLowerCase?.()) >= 0}
        disabled={false}
        onChange={handleCustomerChange}
      >
        {customers?.map(customer => (
          <Option key={customer?.crn} value={customer.crn}>
            {`${customer.id} / ${customer.name}`}
          </Option>
        ))}
      </Select>
    </Margin>
  );
};

export default Customer;
